import React from "react";
import cn from "../lib/utils/class-name";

const styles = {
  info: "bg-[#EBF4FF] border-[#A2B9D4]",
  danger: "bg-[#FAD7DA] border-[#E63946]",
};

export default function Notification({ children, variant = "info" }) {
  return (
    <div
      className={cn(
        "border rounded-[8px] min-h-[77px] py-[16px] px-[27px] mb-[32px]",
        styles[variant]
      )}
    >
      {children}
    </div>
  );
}
